import React, { useMemo } from "react"

import { SECTION_WRAPPER_MOBILE } from "@/components/public/venue/section_styles"
import i18n from "@/i18n"

import ContactDetails from "./contact_details"
import MapPreview from "./map_preview"
import type { VenueInfoProps } from "./types"

const STYLES = {
  container: SECTION_WRAPPER_MOBILE,
  heading: "text-base font-medium mb-4 mt-0",
  headingLink: "text-[#222] no-underline",
  contentColumn: "flex flex-col gap-y-4 items-start",
} as const

const VenueInfoMobile: React.FC<VenueInfoProps> = ({
  address,
  zipcode,
  city,
  country,
  phone,
  email,
  website,
  venueName,
  latitude,
  longitude,
  socialAccounts,
}) => {
  const hasContactInfo = address || phone || email

  const mapQuery = useMemo(() => {
    const parts = [venueName, address, zipcode, city].filter(Boolean)
    return parts.length > 0 ? parts.join(", ") : null
  }, [venueName, address, zipcode, city])

  if (!hasContactInfo) return null

  return (
    <div id="venue-info" className={STYLES.container} data-testid="public-venue-info-container">
      <h2 className={STYLES.heading}>
        <a href="#venue-info" className={STYLES.headingLink}>
          {i18n.t("app.public.venue.venue_info.title")}
        </a>
      </h2>

      <MapPreview
        latitude={latitude}
        longitude={longitude}
        venueName={venueName}
        mapQuery={mapQuery}
        height="h-[180px]"
      />

      <div className={STYLES.contentColumn}>
        <ContactDetails
          address={address}
          zipcode={zipcode}
          city={city}
          country={country}
          phone={phone}
          email={email}
          website={website}
        />
        {socialAccounts}
      </div>
    </div>
  )
}

export default VenueInfoMobile
